module.exports = __webpack_public_path__ + "static/media/guranteed_job.3ded4256.svg";